{
  "id": "campaign-038",
  "name": "Golden Square",
  "seed": "campaign:38",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......._....",
    "......._....",
    "____________",
    "......._.zzz",
    ".n....._.zn.",
    "......._.z..",
    "*......_.zz*",
    "*......_...*",
    "*......_...*",
    "*T.T..._T.T*",
    "......._....",
    ".,....._...x",
    ",,,...._....",
    ".,....._x...",
    "......._....",
    "..n...#_.n..",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 2,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 5
    }
  ],
  "generatorVersion": 3,
  "level": 38,
  "biome": "park",
  "par": {
    "reel": 6770,
    "push": 5781,
    "selfPropelled": 5382,
    "tractor": 4705,
    "zeroTurn": 3646,
    "fairway": 2532
  },
  "routeTries": {
    "par": {
      "reel": 24,
      "push": 5,
      "selfPropelled": 7,
      "tractor": 0,
      "zeroTurn": 2,
      "fairway": 24
    }
  }
}
